import { usePropertyStructureType } from '../../../../queries/PropertyFields/TopLevelFields';
import { usePropertyNumberUnits, usePropertyUnitsIncomeRestricted } from '../../../../queries/PropertyFields/NonRentalCoreFields';
import { StructureType } from '../StructureType';
import { ShowIf } from '../../../components/ShowIf';
import { UnitsDropDown } from './components/UnitsDropDown';
import { IncomeRestrictedUnitsDropDown } from './components/IncomeRestrictedUnitsDropDown';

interface StructureAndUnitsProps {
    propertyGuid: string;
    isReview?: boolean;
}
export const StructureAndUnits: React.FC<StructureAndUnitsProps> = ({ propertyGuid, isReview = false }) => {
    const [structureType] = usePropertyStructureType(propertyGuid);
    const [numberUnits] = usePropertyNumberUnits(propertyGuid);
    const [, set_unitsIncomeRestricted] = usePropertyUnitsIncomeRestricted(propertyGuid);

    const handleStructureTypeChange = (newValue: any) => {
        const diffValue = newValue != structureType;
        if (diffValue) {
            set_unitsIncomeRestricted(undefined);
        }
    };

    return (
        <>
            <StructureType
                propertyGuid={propertyGuid}
                isReview={isReview}
                onValueChange={(newValue) => handleStructureTypeChange(newValue)}
            />
            <ShowIf showIf={structureType === '5+ Unit'}>
                <UnitsDropDown
                    propertyGuid={propertyGuid}
                    isReview={isReview}
                />
                <ShowIf showIf={numberUnits != undefined && numberUnits > 0}>
                    <IncomeRestrictedUnitsDropDown
                        propertyGuid={propertyGuid}
                        isReview={isReview}
                        numberOfUnits={numberUnits}
                    />
                </ShowIf>
            </ShowIf>
        </>
    );
};
